import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

class MinusAndPlusInput extends Component {
  constructor(props) {
    super(props);

    this.state = { value: props.value || 1 };

    this.incrementQuantity = this.incrementQuantity.bind(this);
    this.decrementQuantity = this.decrementQuantity.bind(this);
  }

  componentDidMount() {
    let value = 1;
    this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
      this.setState({ value: newProps.value });
  }

  incrementQuantity() {
    if (this.state.value < this.props.maximum) {
      this.setState(prevState => ({ value: prevState.value + 1 }));
      let value = this.state.value
      this.props.dispatch({ type: types.FORM_INPUT, value: value + 1, name: this.props.name });
    }
  }

  decrementQuantity() {
    if (this.state.value > this.props.minimum) {
      this.setState(prevState => ({ value: prevState.value - 1 }));
      let value = this.state.value;
      this.props.dispatch({ type: types.FORM_INPUT, value: value - 1, name: this.props.name });
    }
  }

  onChange = (event) => {
    const { minimum, maximum } = this.props;
    const inputValue = event.target.value;
    let value;
    if (inputValue === "") {
      value = inputValue;
    } else if (inputValue >= minimum && inputValue <= maximum) {
      value = Number(inputValue);
    } else if (inputValue < minimum) {
      value = minimum;
    } else if (inputValue > maximum) {
      value = maximum;
    }
    this.setState({ value });
    this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name })
  }

  render() {
    const p = this.props;

    switch (p.UnitOfMeasurement) {
      case "Weight":
        return (
          <div className="input-group minus-plus-component">
            <span className="input-group-btn">
              <button type="button" className="btn btn-danger btn-number btn-number-pos" onClick={this.decrementQuantity} data-type="minus" data-field="quant[2]">
                <span className="glyphicon glyphicon-minus"></span>
              </button>
            </span>
            <input type="number" name={p.name} step="0.01" className="form-control input-number input-number-pos" value={this.state.value} min={p.minimum} max={p.maximum} />
            <span className="input-group-btn">
              <button type="button" className="btn btn-number btn-number-pos btn-success" onClick={this.incrementQuantity} data-type="plus" data-field="quant[2]">
                <span className="glyphicon glyphicon-plus"></span>
              </button>
            </span>
          </div>
        );
      default:
        return (<div className="input-group minus-plus-component">
          <section style={{ position: 'relative', display: "flex" }}>
            <IconButton onClick={this.decrementQuantity} sx={{ padding: "0px" }} id="minus-button">
              <RemoveIcon />
            </IconButton>
            <TextField variant="standard" name={p.name} value={p.value || 1}
              min={p.minimum} max={p.maximum} onChange={this.onChange} id="text-field-minusplus" />
            <IconButton onClick={this.incrementQuantity} sx={{ padding: "0px" }} id="plus-button">
              <AddIcon />
            </IconButton>
          </section>
        </div>);
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    value: state.form[props.name]
  };
};

export default connect(mapStateToProps)(MinusAndPlusInput);
